import { lazy } from "react";
import { enumPermisosPinesColpatriaCRC } from "./enumPermisosPinesColpatriaCRC";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/** Rutas */
const PinesCrcTrx = lazy(() => import("./PinesCrcTrx"));

const PinesVenta = lazy(() => import("./Views/Pines/VentaPines"));
const PeticionesPines = lazy(() => import("./Views/Peticiones"));
const AnulacionesPines = lazy(() => import("./Views/Pines/AnulacionPines"));


const listPermissions = Object.values(
  enumPermisosPinesColpatriaCRC
);
export const listPermissionPermisosPinesColpatriaCRC = listPermissions;

const rutasPinesCrc = {
  link: "/Pines/PinesCrc",
  label: <AppIcons Logo={"PINES_GENERACION_LICENCIA"} name={"Pines CRC"} />,
  component: PinesCrcTrx,
  permission: listPermissionPermisosPinesColpatriaCRC,
  subRoutes: [
    {
      link: "/Pines/PinesCrc/Ventapines",
      label: <AppIcons Logo={"PINES_CREAR"} name={"Crear Pin CRC"} />,
      component: PinesVenta,
      permission: listPermissionPermisosPinesColpatriaCRC,
      subRoutes: [
        {
          link: "/Pines/PinesCrc/pines/:id_convenio_pin",
          label: <AppIcons Logo={"PINES_CREAR"} name={"Venta de Pines CRC"} />,
          component: PinesVenta,
          permission: [enumPermisosPinesColpatriaCRC.CREAR_PIN],
          show: false,
        },
      ],
    },
    {
      link: "/Pines/PinesCrc/PeticionesPines",
      label: <AppIcons Logo={"PINES_TRAMITAR"} name={"Peticiones"} />,
      component: PeticionesPines,
      permission: [enumPermisosPinesColpatriaCRC.PETICION_ANULACION],
    },
    {
      link: "/Pines/PinesCrc/AnulacionPines",
      label: <AppIcons Logo={"PINES_CREAR"} name={"Anulación Pines OAT"} />,
      component: AnulacionesPines,
      permission: [enumPermisosPinesColpatriaCRC.ANULACION_PINES],
    },
  ],
};

export default rutasPinesCrc;
